import React, { useEffect,useState,useContext } from "react";
import CloseCross from "../../../../assets/images/closeCrossBlack.svg";
import "./Icons.scss";
import Axios from "../../../../axios/index";
import * as UTILS from "../../../../utils/Utils"
import { DragAndDropContext } from "../../../../context/DragAndDropContext";
const Icons = (props) => {
  const { onDrag } = useContext(DragAndDropContext);
  const img = UTILS.tool[5]
  
  const [imageURLArray, setImageURLArray] = useState([]);
  useEffect(() => {
    Axios.FlimpIconsService.GET_FLIMP_ICONS().then((res) => {
      if (res) {
        setImageURLArray(res.data);
      }
    });
  },[]);
  return (
    <div className="sideblocksPanel">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          paddingLeft: "12px",
          paddingTop: "12px",
        }}
      >
        <div className="icons-header">Flimp Icons</div>
        <button
          onClick={props.close}
          style={{
            border: "0",
            height: "40px",
            width: "30px",
            background: "#eee",
          }}
        >
          <img src={CloseCross} />
        </button>
      </div>
      <div className="icons-scroll-container">
        <div className="icons-row">
          {imageURLArray.map((image) => {
            return (
              <div className="icon-container">
                <img
                  onDrag={(e) => {
                   onDrag(e, { ...img, src: image.iconUrl },{ data: "toolbar",id:"toolbar" });
                  }}
                  height="70px"
                  width="70px"
                  src={image.iconUrl}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Icons;
